import TextRowInfo from "./text-row-info";

export default TextRowInfo;
